import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRow: null,
  formData: {
    komoditas_id: '',
    komoditas_name: '',
    komoditas_createdate: '',
    komoditas_updatedate: '',
    komoditas_isdisable: 0,
    komoditas_createdby: '',
    komoditas_updatedby: '',
    rowid: '',
  },
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
};

const mst07komoditasSlice = createSlice({
  name: 'mst07komoditas',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    setFormData: (state, action) => { state.formData = action.payload; },
    clearFormData: (state) => { state.formData = initialState.formData; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialState.formData, ...action.payload };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: () => initialState,
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.formData = initialState.formData;
    },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
  },
});

export const { setSelectedRow, setFormData, clearFormData, setLoading, setErrorMsg, setLoadingMessage, fetchDetailSuccess, fetchDetailFailure, fetchDetailError, resetState, updateFormData, setActiveTab, setDataList, setTotalData, clearModuleState } = mst07komoditasSlice.actions;

export default mst07komoditasSlice.reducer;
